import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { fade, makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    menuItem: {
        fontSize: pxToRem(16),
        '&:hover': {
            backgroundColor: fade('#29e3bf', 0.2),
            cursor: 'pointer',
        },
    },
}))

export interface ListingStateVariantProps {
    onChange?: (value: string) => void
}

const ListingStateVariant: React.FC<ListingStateVariantProps> = ({
    onChange,
}) => {
    const classes = useStyles()

    const handleChange = (value: string) => () => {
        onChange?.(value)
    }

    return (
        <List data-testid={'optionList'}>
            <ListItem
                className={classes.menuItem}
                onClick={handleChange('Active')}
                data-testid={'activeOption'}
            >
                Active
            </ListItem>
            <ListItem
                className={classes.menuItem}
                onClick={handleChange('Inactive')}
                data-testid={'inactiveOption'}
            >
                Inactive
            </ListItem>
        </List>
    )
}

export default ListingStateVariant
